<template lang="pug">
  div
    Header
    .mt-5.d-flex.justify-content-center.align-items-center
      form(@submit.prevent)
        .p-5.bg-white.rounded
          figure.text-center
            img(
              src="/static/img/app/icon-videochat_room.png"
              width="80"
            )
          h2.h4.font-weight-bold.text-center
            | ビデオチャットで使うルームを作成する
          .d-flex.align-items-center.justify-content-center.py-3
            span.fsz-15.text-nowrap
              | https://goq.me/
            input.ml-2.w-75.form-control(
              type="text",
              size="10",
              v-model="roomName"
            )
          p.mb-3.text-center.text-nowrap.fsz-13
            | 3文字以上、半角英数字、「-（ハイフン）」が利用可能です。
          button.btn.btn-block.btn-success(
            type="submit",
            @click="handleClick"
          )
            | ルームを作成する
    GoQApps
</template>

<script>
import Header from '../components/header/BaseSimple'
import GoQApps from '../components/widget/GoQApps'

export default {
  components: {
    Header,
    GoQApps
  },
  data () {
    return {
      roomName: ''
    }
  },
  methods: {
    handleClick () {
      let errorMessage = ''

      if (!this.roomName) {
        errorMessage = 'ルーム名を入力してください'
      } else {
        // 半角英数-以外なら
        // eslint-disable-next-line no-useless-escape
        const pattern = /^[A-Za-z0-9\-]*$/g
        if (!this.roomName.match(pattern)) {
          errorMessage = 'ルーム名は半角英数字・「-（ハイフン）」で入力してください'
        } else {
          // 文字数が3文字未満なら
          if (this.roomName.length < 3) {
            errorMessage = 'ルーム名は3文字以上で入力してください'
          }
        }
      }

      if (errorMessage) {
        alert(errorMessage)
        return
      }

      this.$router.push({
        path: this.roomName
      })
    }
  }
}
</script>
